import { render, staticRenderFns } from "./BottomButton.vue?vue&type=template&id=61626b9d&scoped=true&"
import script from "./BottomButton.vue?vue&type=script&lang=ts&"
export * from "./BottomButton.vue?vue&type=script&lang=ts&"
import style0 from "./BottomButton.vue?vue&type=style&index=0&id=61626b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61626b9d",
  null
  
)

export default component.exports